import type { Entitlements } from '../../types';
import { isLocalEnvironment } from '../../utils/environment';
import { axiosClient } from '../client/AxiosClient';

export const fetchEntitlementsData = async (): Promise<Entitlements> => {
  // If running locally, use the local Express server
  // throw new Error('simulated error for testing');
  if (isLocalEnvironment()) {
    const { data } = await axiosClient.get<Entitlements>(
      'http://localhost:3001/api/entitlements',
    );

    return data;
  }
  // Otherwise use the axios client for remote environments
  const { data } = await axiosClient.get<Entitlements>('/api/entitlements');

  return data;
};
